<template>
  <div v-if="showCarousel && showContainer" :id="carouselSettings.carouselId" class="carousel slide" :class="[carouselSettings.crossfade ? 'carousel-fade' : '', globalClasses]" data-ride="carousel" :style="[globalStyle]">
    <ol v-if="carouselSettings.indicators" class="carousel-indicators">
      <li v-for="(el, i) in columns" :data-target="'#'+carouselSettings.carouselId" :data-slide-to="i" :class="[i===0 ? 'active' : '', `bg-${carouselSettings.apperance}`]"/>
    </ol>
    <div class="carousel-inner">
      <div  v-for="(col, index) in $slots.columns" :key="index" class="carousel-item" :class="[index===0 ? 'active' : '']">
        <div class="widget-inner" :class="classColumns[index]" :style="[stylesColumns[index]]">
          <slot-component :vnode="col"/>
        </div>
      </div>
    </div>
    <a v-if="carouselSettings.controls" class="carousel-control-prev" :href="'#'+carouselSettings.carouselId" role="button" data-slide="prev">
      <span class="fa fa-chevron-left fa-lg" :class="'text-'+carouselSettings.apperance" aria-hidden="true"/>
      <span class="sr-only">Previous</span>
    </a>
    <a v-if="carouselSettings.controls" class="carousel-control-next" :href="'#'+carouselSettings.carouselId" role="button" data-slide="next">
      <span class="fa fa-chevron-right fa-lg" :class="'text-'+carouselSettings.apperance" aria-hidden="true"/>
      <span class="sr-only">Next</span>
    </a>
  </div>
  <div v-else-if="showContainer && columns===2" class="widget-grid widget-two-col row" :class="[noGutters, globalClasses]" :style="[globalStyle]">
    <div v-for="(col, index) in $slots.columns" :key="index" :id="idColumns[index]"
         class="widget-inner" :class="[classGrids[index] ,classColumns[index]]" :style="[stylesColumns[index]]">
      <slot-component :vnode="col"/>
    </div>
  </div>
  <div v-else-if="showContainer && columns===3" class="widget-grid widget-three-col row" :class="[noGutters, globalClasses]" :style="[globalStyle]">
    <template v-if="layout==='oneStackedToTwo'">
      <div class="widget-inner widget-inner-stacked col-12" :class="[layoutTablet === 'stackedTablet' ? 'tablet-stacked' : '',classGrids[0]]">
        <div class="widget-inner row" :class="[noGutters]">
          <slot-component :vnode="$slots.columns[0]"/>
        </div>

        <div class="widget-inner row" :class="[noGutters]">
          <slot-component :vnode="$slots.columns[1]"/>
        </div>
      </div>
      <div class="widget-inner col-12" :id="idColumns[2]" :class="[classGrids[1], classColumns[2]]" :style="[stylesColumns[2]]">
        <slot-component :vnode="$slots.columns[2]"/>
      </div>
    </template>
    <template v-else-if="layout==='twoToOneStacked'">
      <div class="widget-inner col-12" :id="idColumns[0]" :class="[classGrids[0], classColumns[0]]" :style="[stylesColumns[0]]">
        <slot-component :vnode="$slots.columns[0]"/>
      </div>
      <div class="widget-inner widget-inner-stacked col-12" :class="[layoutTablet === 'stackedTablet' ? 'tablet-stacked' : '',classGrids[1]]">
        <div class="widget-inner row" :class="[noGutters]">
          <slot-component :vnode="$slots.columns[1]"/>
        </div>

        <div class="widget-inner row" :class="[noGutters]">
          <slot-component :vnode="$slots.columns[2]"/>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-for="(col, index) in $slots.columns" :key="index" :id="idColumns[index]" class="widget-inner col-12" 
      :class="[classGrids[index], classColumns[index]]" :style="[stylesColumns[index]]" >
        <slot-component :vnode="col"/>
      </div>
    </template>
  </div>
  <div v-else-if="showContainer && columns===4" class="widget-grid widget-four-col row" :class="[noGutters, globalClasses]" :style="[globalStyle]">
    <template v-if="layout === 'oneStackedToTwo' || layout === 'oneStackedToOne' || layout === 'twoStackedToOne'">
      <div class="widget-inner widget-inner-stacked grid-four col-12" :class="[layoutTablet === 'stacked' ? 'tablet-stacked' : '',classGrids[0]]">
        <div class="widget-inner row" :class="[noGutters]"><slot-component :vnode="$slots.columns[0]"/></div>
        <div class="widget-inner row" :class="[noGutters]"><slot-component :vnode="$slots.columns[1]"/></div>
        <div class="widget-inner row" :class="[noGutters]"><slot-component :vnode="$slots.columns[2]"/></div>
      </div>
      <div class="widget-inner col-12" :id="idColumns[3]" :class="[classGrids[1], classColumns[3]]" :style="[stylesColumns[3]]">
        <slot-component :vnode="$slots.columns[3]"/>
      </div>
    </template>
    <template v-else-if="layout === 'twoToOneStacked' || layout === 'oneToOneStacked' || layout === 'oneToTwoStacked'">
      <div class="widget-inner col-12" :id="idColumns[0]" :class="[classGrids[0], classColumns[0]]" :style="[stylesColumns[0]]">
        <slot-component :vnode="$slots.columns[0]"/>
      </div>
      <div class="widget-inner widget-inner-stacked grid-four col-12" :class="[layoutTablet === 'stacked' ? 'tablet-stacked' : '',classGrids[1]]">
        <div class="widget-inner row" :class="[noGutters]"><slot-component :vnode="$slots.columns[1]"/></div>
        <div class="widget-inner row" :class="[noGutters]"><slot-component :vnode="$slots.columns[2]"/></div>
        <div class="widget-inner row" :class="[noGutters]"><slot-component :vnode="$slots.columns[3]"/></div>
      </div>
    </template>
    <template v-else>
      <div v-for="(col, index) in $slots.columns" :key="index" :id="idColumns[index]" class="widget-inner col-12"
           :class="[classGrids[index], classColumns[index]]" :style="[stylesColumns[index]]" >
        <slot-component :vnode="col"/>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  components: {
    SlotComponent: {
      functional: true,
      render: (createElement, context) => context.data.attrs.vnode
    }
  },
  props: {
    globalStyle: {type: Object},
    globalClasses: {type: String},
    columns: {type: Number},
    classColumns: { type: Array },
    classGrids: {type: Array},
    carouselMobile: {type: Boolean},
    carouselTablet: {type: Boolean},
    carouselSettings: {type: Object},
    displayContainer: {type: Object},
    stylesColumns: {type: Array},
    idColumns: {type: Array},
    noGutters : { type: String},
    layout : { type: String},
    layoutTablet:{type: String} 
  },
  data () {
    return {
      display: 'sm',
    }
  },
  computed:{
    showCarousel(){
      if(this.carouselMobile && (this.display === 'sm' || this.display === 'xs')){
        return true
      }else if(this.carouselTablet && (this.display === 'md')){
        return true
      }
      return false
    },
    showContainer(){
      if(this.displayContainer.sm && this.displayContainer.md && this.displayContainer.lg){
        return true
      }else if((this.displayContainer.sm && this.displayContainer.md && !this.displayContainer.lg) && this.display!=='lg'){ // Show in Mobile, Tablet
        return true
      }else if((this.displayContainer.sm && !this.displayContainer.md && !this.displayContainer.lg) && (this.display==='xs' || this.display==='sm')){ // Show in Mobile
        return true
      }else if((this.displayContainer.sm && !this.displayContainer.md && this.displayContainer.lg) && (this.display!=='md')){// Show in Mobile , Desktop
        return true
      }else if((!this.displayContainer.sm && !this.displayContainer.md && this.displayContainer.lg) && (this.display==='lg')){ // Show in  Desktop
        return true
      }else if((!this.displayContainer.sm && this.displayContainer.md && this.displayContainer.lg) && (this.display==='md' || this.display==='lg')){ // Show in Tablet, Desktop
        return true
      } else if((!this.displayContainer.sm && this.displayContainer.md && !this.displayContainer.lg) && (this.display==='md')){ // Show in Tablet
        return true
      }
      return false
    }
  },
  mounted () {
    this.onInit(window.innerWidth)
    window.addEventListener('resize', this.onResize)
  },
  methods: {
    onResize () {
      if (window.innerWidth > 992) {
        this.display = 'lg'
      } else if (window.innerWidth > 768) {
        this.display = 'md'
      } else if (window.innerWidth > 576) {
        this.display = 'sm'
      } else {
        this.display = 'xs'
      }
    },
    onInit (size) {
      if (size > 992) {
        this.display = 'lg'
      } else if (size > 768) {
        this.display = 'md'
      } else if (window.innerWidth > 576) {
        this.display = 'sm'
      } else {
        this.display = 'xs'
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  }

}

</script>